<template>
  <img class="gia-photo" src="/local/templates/love-you/images/gia_logo_png.png" alt="gia" />
</template>

<script>
export default {
  name: 'GiaPhoto',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.gia-photo {
  display: block;
  max-width: 42px;
}
</style>
